// Generated Musical Stories Data for ExploreStoriesPage
// Auto-generated from musical videos in musicals_final folder

export interface MusicalStory {
  storyId: string;
  userId: string;
  title: string;
  description: string;
  prompt: string;
  moral: string | null;
  narrator: string | null;
  narratorName: string;
  reader: string;
  styleId: string;
  styleName: string;
  storyMode: string;
  storyLanguage: string;
  createdAt: string;
  chapterIds: string[];
  imageUrl: any;
  status: string;
  tokensUsed: number;
}

export const musicalStoriesData: MusicalStory[] = [
    // Featured Musicals
    {
      storyId: 'e3edb288-65f8-4ce5-8ce3-c0bafca2309b',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Watch the Magic Unfold",
      description: "A fast cinematic Fable musical promo where one hooded runner follows a blue spark through an enchanted forest and unlocks a whole story world.",
      prompt: "Watch the Magic Unfold - A hooded forest runner chases a blue spark, discovers a distant dragon, and turns the adventure into a magical Fable book.",
      moral: "Imagination",
      narrator: null,
      narratorName: "Musical",
      reader: "Adult",
      styleId: "ink-toon",
      styleName: "Ink Toon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2026-06-01T00:00:00.000Z",
      chapterIds: ["e3edb288-65f8-4ce5-8ce3-c0bafca2309b"],
      imageUrl: '/story-thumbnails/watchthemagicunfold.jpg',
      status: "published",
      tokensUsed: 1
    },
    {
      storyId: '1d644c4c-819b-4297-8827-ce779b5bcd93',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Princess Rosalind's Magical Town Ball Adventure ✨👑",
      description: "👑 Join Princess Rosalind on a heartwarming adventure! 💃✨",
      prompt: "Princess Rosalind transforms the traditional Town Ball into a magical celebration that brings the entire kingdom together, showing that true leadership means breaking down barriers and celebrating what unites us all.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "childrens-storybook",
      styleName: "Childrens Storybook",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-12-21T00:00:00.000Z",
      chapterIds: ["1d644c4c-819b-4297-8827-ce779b5bcd93"],
      imageUrl: '/music/princess.jpeg',
      status: "published",
      tokensUsed: 1
    },
    {
      storyId: '7eb00336-8c10-4cd4-ae03-e10c2cb2c2e5',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Sam and the Magical Red Dragon: An Epic Journey Above the Clouds",
      description: "🐉 Join Sam on an incredible adventure with a magical red dragon! ✨",
      prompt: "Watch as an unlikely friendship forms between a brave young explorer and a magnificent dragon with shimmering ruby scales. Together, they soar through the skies on an epic journey across lush grass plains, over the vibrant blue ocean, and into the clouds where magic awaits!",
      moral: "Friendship",
      narrator: null,
      narratorName: "Musical",
      reader: "Adult",
      styleId: "3d-cartoon",
      styleName: "3D Cartoon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-12-21T00:00:00.000Z",
      chapterIds: ["7eb00336-8c10-4cd4-ae03-e10c2cb2c2e5"],
      imageUrl: '/music/dragon.jpeg',
      status: "published",
      tokensUsed: 1
    },
    {
      storyId: '87ff20d7-6d1e-4305-8f7d-1fa752ba053a',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Hyperion Academy: Alex Martinez's Fire Awakening 🔥",
      description: "🦸‍♂️ Watch Alex Martinez go from powerless outcast to fierce fire-wielding hero! 🔥⚡",
      prompt: "At Hyperion Academy, the world's most prestigious superhero high school, fifteen-year-old Alex Martinez has spent his first semester feeling like an outsider. While his classmates fly through the sky, turn invisible, or move objects with their minds, Alex remains powerless, the only student whose abilities haven't manifested yet. When his superhero abilities finally awaken during a dangerous training accident, Alex must learn to control his blazing new fireballs before they consume everything and everyone around him.",
      moral: "Perseverance",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "comic-book",
      styleName: "Comic Book",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-12-21T00:00:00.000Z",
      chapterIds: ["87ff20d7-6d1e-4305-8f7d-1fa752ba053a"],
      imageUrl: '/music/super.jpeg',
      status: "published",
      tokensUsed: 1
    },
    // Other Musical Stories
    {
      storyId: 'ac4eb6a8-60e8-4d1d-a7a0-c0de338bcf1c',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Velvet Shadow Detective Agency",
      description: "🎷 Welcome to The Velvet Shadow Detective Agency! 🕵️‍♀️🌙🎩",
      prompt: "In a noir-style city, a young detective known as The Velvet Shadow uses jazz music to solve mysteries. With smooth jazz melodies and mysterious lyrics, follow along as clues are uncovered through musical investigation in this sophisticated mystery adventure.",
      moral: "Truthfulness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:44:36.839Z",
      chapterIds: ["ac4eb6a8-60e8-4d1d-a7a0-c0de338bcf1c"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_1_the_velvet_shadow_detective_agency.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '472c8afd-60d3-4c05-bd1c-b6b66aa4c661',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Midnight Storybook Café",
      description: "☕ Welcome to The Midnight Storybook Café! ✨🎶📖",
      prompt: "A magical jazz café called The Midnight Storybook appears only at midnight where fairy tale characters come to perform. With smooth jazz and enchanting harmonies, each character tells their story through song, teaching lessons about empathy and understanding.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:45:37.577Z",
      chapterIds: ["472c8afd-60d3-4c05-bd1c-b6b66aa4c661"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_2_the_midnight_storybook_caf.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'd74b647b-01a1-4449-8b32-c3920a964f23',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Love Notes from the Valentine Jazz Orchestra",
      description: "💕 Fall in love with Love Notes from the Valentine Jazz Orchestra! 🎷💌🎺",
      prompt: "A shy jazz musician in the Valentine Jazz Orchestra writes love letters through music for a special someone. With romantic jazz melodies and heartfelt lyrics, learn about expressing feelings honestly and the courage it takes to share your heart.",
      moral: null,
      narrator: null,
      narratorName: "Musical",
      reader: "Adult",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:51:07.703Z",
      chapterIds: ["d74b647b-01a1-4449-8b32-c3920a964f23"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_3_love_notes_from_the_valentine_jazz_orchestra.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'f96c413a-da47-4590-bd03-f56280303693',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Symphony of Heroes: The Timeless Orchestra",
      description: "🎻 Presenting Symphony of Heroes: The Timeless Orchestra! 👑⚔️✨🎼",
      prompt: "Legendary heroes from different eras are brought together by the Timeless Orchestra, a magical ensemble. With classical symphonic music, they must work together to create a perfect harmony that will save their worlds from eternal silence.",
      moral: "Reliability",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:52:08.454Z",
      chapterIds: ["f96c413a-da47-4590-bd03-f56280303693"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_4_symphony_of_heroes_the_timeless_orchestra.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'f7c812dd-ccdc-40f1-ad11-e4c7fc62cfcd',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Princess Aurora's Starlight Symphony Ball",
      description: "👑 You're Invited to Princess Aurora's Starlight Symphony Ball! 💃🎻⭐",
      prompt: "Princess Aurora invites everyone in the kingdom to a grand Starlight Symphony Ball. With beautiful classical waltzes and orchestral arrangements, children of all backgrounds dance together under the stars, learning that music brings everyone together regardless of their differences.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:53:09.250Z",
      chapterIds: ["f7c812dd-ccdc-40f1-ad11-e4c7fc62cfcd"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_5_princess_auroras_starlight_symphony_ball.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '2e374d52-ec8c-42cf-917d-a9ede5fc0594',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Phantom of the Grand Apollo Theater",
      description: "🎭 Unmask The Phantom of the Grand Apollo Theater! 🎻👻🏛️",
      prompt: "A mysterious phantom haunts the Grand Apollo Theater, communicating only through dramatic classical music. Young musicians must solve the musical mystery and discover the phantom's sad tale, learning about empathy and second chances.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:54:10.078Z",
      chapterIds: ["2e374d52-ec8c-42cf-917d-a9ede5fc0594"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_6_the_phantom_of_the_grand_apollo_theater.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '46bb27f5-7438-43dc-807d-338c6bb6e9cf',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Rhythm City Rap Academy: Battle of Champions",
      description: "🎤 Welcome to Rhythm City Rap Academy! 🦸‍♀️💥🏙️",
      prompt: "At Rhythm City Rap Academy, students train their superhero powers through rap battles. With hip hop beats and clever wordplay, young heroes learn to use their voice as their greatest power while staying true to themselves.",
      moral: "Truthfulness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:55:10.703Z",
      chapterIds: ["46bb27f5-7438-43dc-807d-338c6bb6e9cf"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_7_rhythm_city_rap_academy_battle_of_champions.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'e0a41d58-8107-46ed-8852-da81022334c9',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "DJ Beats and the Pocket Beats League",
      description: "🎤 It's DJ Beats and the Pocket Beats League! 👑🐉🎧",
      prompt: "A young trainer named DJ Beats from the city brings hip hop culture to creature training in the Pocket Beats League. With rap lyrics about friendship and strategy, follow this urban adventure as they compete to become the greatest creature trainer while keeping it real.",
      moral: null,
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "3d-cartoon",
      styleName: "3D Cartoon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:56:11.479Z",
      chapterIds: ["e0a41d58-8107-46ed-8852-da81022334c9"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_8_dj_beats_and_the_pocket_beats_league.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'e82d2920-41d0-4391-ae7d-3548244bf137',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Wandering Storyteller's Journey",
      description: "🎻 Join The Wandering Storyteller's Journey! 🌄📖🎸",
      prompt: "A young bard known as The Wandering Storyteller travels from village to village sharing folk stories through song. With traditional acoustic melodies and timeless lyrics, each tale teaches ancient wisdom about courage, kindness, and the connections between all living things.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:58:13.088Z",
      chapterIds: ["e82d2920-41d0-4391-ae7d-3548244bf137"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_9_the_wandering_storytellers_journey.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'e3d5b02c-7ba1-437d-a06e-b2beb24f78ee',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Power-Up Champions: The Crystal City Tournament",
      description: "🎵 Welcome to Power-Up Champions! 🦸‍♀️🦸‍♂️",
      prompt: "A musical story about kids at the Crystal City Hero Training Center where they learn to fly, master their elemental powers, and compete in the legendary Power-Up Championship. Set to upbeat pop music with catchy choruses as heroes train and face their biggest challenge.",
      moral: "Perseverance",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:35:29.992Z",
      chapterIds: ["e3d5b02c-7ba1-437d-a06e-b2beb24f78ee"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_10_power_up_champions_the_crystal_city_tournament.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '31c7e81a-4c9b-44cd-b455-136279f84fca',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Seeds of Tomorrow: The Gardener's Song",
      description: "🌱 Plant hope with Seeds of Tomorrow: The Gardener's Song! 🎵🌻🌾",
      prompt: "A young traveling farmer-musician teaches people to plant seeds and sing folk songs about hope and growth. With acoustic folk melodies and nature themes, children learn that small actions today create beautiful tomorrows.",
      moral: null,
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T03:00:14.632Z",
      chapterIds: ["31c7e81a-4c9b-44cd-b455-136279f84fca"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_11_seeds_of_tomorrow_the_gardeners_song.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '153186c7-07bd-48d8-816f-2802e8e530d7',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Smokey Joe's Detective Blues",
      description: "🎸 Step into Smokey Joe's Detective Blues! 🕵️‍♂️🌃🎩",
      prompt: "A private detective named Smokey Joe with a guitar solves mysteries in a 1940s city using blues music. Each case teaches about empathy and understanding others' struggles, all set to emotional blues melodies that reveal the truth.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Adult",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T03:07:19.642Z",
      chapterIds: ["153186c7-07bd-48d8-816f-2802e8e530d7"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_12_smokey_joes_detective_blues.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '8116dee0-c217-4462-8990-ec3963a86c62',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Soul Brothers: Harmony House Mission",
      description: "🎸 Meet The Soul Brothers: Harmony House Mission! 👬🎵🏠",
      prompt: "Two brothers with opposite personalities, The Soul Brothers, reunite through blues music to save their childhood Harmony House community center. With soulful blues and gospel influences, they learn that family and perseverance can overcome any obstacle.",
      moral: "Perseverance",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "3d-cartoon",
      styleName: "3D Cartoon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T03:08:20.325Z",
      chapterIds: ["8116dee0-c217-4462-8990-ec3963a86c62"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_13_the_soul_brothers_harmony_house_mission.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'c4f427c8-6497-49dc-ad2c-69b32e9bba12',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "The Glitter Ghouls Talent Spectacular",
      description: "🎵 Get ready to rock with The Glitter Ghouls! 🎸👾",
      prompt: "A group of friendly monsters form a pop band called The Glitter Ghouls to win their school's talent show. With colorful characters and catchy pop songs, they learn that being different makes them special as they rock out together.",
      moral: "Friendship",
      narrator: null,
      narratorName: "Musical",
      reader: "Toddler",
      styleId: "3d-cartoon",
      styleName: "3D Cartoon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:36:30.830Z",
      chapterIds: ["c4f427c8-6497-49dc-ad2c-69b32e9bba12"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_14_the_glitter_ghouls_talent_spectacular.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'ec242102-78bb-4ba8-b4ed-1f47675bf4e7',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Princess Daisy's Harvest Moon Ball",
      description: "👑 Welcome to Princess Daisy's Harvest Moon Ball! 💃🌼🌕",
      prompt: "Princess Daisy hosts a magical country-themed ball under the harvest moon where kids from all over the kingdom come to dance. Set to warm country music with fiddles and acoustic guitars, everyone learns that true royalty comes from having a kind heart, not a crown.",
      moral: "Kindness",
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "3d-cartoon",
      styleName: "3D Cartoon",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:39:33.139Z",
      chapterIds: ["ec242102-78bb-4ba8-b4ed-1f47675bf4e7"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_15_princess_daisys_harvest_moon_ball.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: '11953000-405c-45ec-8386-7c23f0d77b46',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Whispering Willow Ranch Lullabies",
      description: "🌅 Wind down with Whispering Willow Ranch Lullabies! 🤠🐴🌾",
      prompt: "On the peaceful Whispering Willow Ranch at sunset, a young rancher sings calming country lullabies to the animals. With gentle acoustic guitar and serene vocals, learn about patience, kindness to animals, and finding peace in nature.",
      moral: null,
      narrator: null,
      narratorName: "Musical",
      reader: "Toddler",
      styleId: "watercolor",
      styleName: "Watercolor",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:40:33.883Z",
      chapterIds: ["11953000-405c-45ec-8386-7c23f0d77b46"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_16_whispering_willow_ranch_lullabies.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    },
    {
      storyId: 'ea128301-c1ac-446d-8fb0-a9e415719716',
      userId: 'd46046ba-8cb0-45be-b338-5f6f98b6a223',
      title: "Battle of the Bands: The Prophecy of Five",
      description: "⚡ Rock out with Battle of the Bands: The Prophecy of Five! 🎸🌍🔮",
      prompt: "Five rival rock bands must unite when an ancient prophecy reveals only their combined music can save the world from eternal silence. With intense rock anthems and dramatic solos, they learn that former enemies can become the strongest allies.",
      moral: null,
      narrator: null,
      narratorName: "Musical",
      reader: "Teen",
      styleId: "anime",
      styleName: "Animation",
      storyMode: "Musical",
      storyLanguage: "en",
      createdAt: "2025-11-11T02:43:36.030Z",
      chapterIds: ["ea128301-c1ac-446d-8fb0-a9e415719716"],
      imageUrl: require('../components/images/musicalthumbnails/musical_story_17_battle_of_the_bands_the_prophecy_of_five.jpeg'),
      status: "scheduled",
      tokensUsed: 1
    }
];
